import React from 'react'
import { Text } from '@mantine/core'
import ErrorMessage from '../components/error-message'
export default function NotFound() {
    return (
        <ErrorMessage title="Not Found" subtitle="You have navigated to a wrong page" /> 
    )
}